export const TINY_FONT_SIZE_PX = 12;
export const SMALL_FONT_SIZE_PX = 14;
export const NORMAL_FONT_SIZE_PX = 16;
export const BIG_FONT_SIZE_PX = 18;
export const LARGE_FONT_SIZE_PX = 20;
export const LARGER_FONT_SIZE_PX = 24;

export const BASE_SIZE = 16;
